module.exports = "/static/assets/8bce2aa48a3393eb61cc3af660946d67.png";